import { showError } from '@calendly/alert'
import { useFormContext } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { isEmpty } from 'lodash-es'
import { useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { useHasFormErrors } from '../sections/hooks'

export const useFormHandleSubmit = ({ validateOnly = false, hasMutationError = false } = {}) => {
  const dispatch = useDispatch()
  const hasErrors = useHasFormErrors()
  const { validateForm, submitForm, isSubmitting } = useFormContext()

  const afterSubmitActionRef = useRef(null)

  useOnValueChange(isSubmitting, () => {
    if (!isSubmitting && afterSubmitActionRef.current) {
      if (!hasErrors && !hasMutationError) {
        afterSubmitActionRef.current()
      }
      afterSubmitActionRef.current = null
    }
  })

  const handleSubmit = useCallback((afterSubmit = null) => {
    afterSubmitActionRef.current = afterSubmit

    return submitForm()
  }, [submitForm])

  return useCallback((onSuccess = null) => {
    if (validateOnly) {
      return validateForm().then((formErrors) => {
        if (!isEmpty(formErrors)) {
          dispatch(showError(I18n.t('publisher.event_type_editor.sections.errors.section')))
          return false
        }

        if (onSuccess) { onSuccess() }
        return true
      })
    }

    return handleSubmit(onSuccess)
  }, [validateOnly, handleSubmit, validateForm, dispatch])
}
